import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {PossibleRequest, TanstackQueryData} from '$constants/api-infos'
import {useUserInfoContext} from '$contexts/member/userInfoStatus'
import {LOGIN_REQUIRED_API_PATH} from '$utils/api'

const useApiQuery = <Response, Request extends PossibleRequest>(
    queryOptions: UseQueryOptions<Response, AxiosError> & ReturnType<TanstackQueryData<Response, Request>['query']>,
) => {
    /**
     * 보험 지면에서만 사용되는 Context
     * 공통으로 쓰려면 withGetServerSideProps에서 memberInfo 분리가 필요합니다.
     * 분리해서 보험 지면에서 UserInfoContext대신 MemberInfoContext를 사용하는 방법이 있습니다.
     */
    const {userInfo} = useUserInfoContext()

    const isLoginRequiredApi = LOGIN_REQUIRED_API_PATH.some(
        (pathname) => queryOptions.queryKey[2] === pathname.replace('/', ''),
    )
    const shouldFetch = isLoginRequiredApi ? userInfo.isSuccessLogin : true

    return useQuery({
        ...queryOptions,
        enabled: (queryOptions.enabled ?? true) && shouldFetch,
    })
}

export default useApiQuery
